
export class Security {
    Id: string;
    AppEngine: string;
    OktaRedirectURL: string;
    FLTRedirectURL: string; x
    OktaClientId: string;
    OktaURL: string;
    OktaIssuer: string;
    WorkspaceURL: string;

    /**
     * Constructor
     *
     * @param security
     */
    constructor() {
        {
            this.Id = '0';
            /*  LocalHost 138
            -------------------------------------------------------------------       
            this.OktaURL = 'https://dev-830132.okta.com';
            this.OktaIssuer = 'https://dev-830132.okta.com/oauth2/default';
            this.OktaRedirectURL = 'http://192.168.0.138:4200/implicit/callback';
            this.OktaClientId = '0oacpzpi4uEI4C9Ig4x7'; 
            this.AppEngine = 'http://localhost:8080/';
            this.WorkspaceURL = 'http://localhost:4200/';
            */
            
            /*  IoT
            -------------------------------------------------------------------
            */
            this.OktaURL = 'https://dev-830132.okta.com';
            this.OktaIssuer = 'https://dev-830132.okta.com/oauth2/default';
            this.AppEngine = 'https://api.flt-lab.com/';
            this.OktaRedirectURL = 'https://iot.flt-lab.com/implicit/callback';
            this.OktaClientId = '0oa3diagf5V9aCxKf4x7';
            this.WorkspaceURL = 'https://iot.flt-lab.com/';
        }
    }
}
